import type { MouseEvent, PointerEvent } from 'react';
import { Button } from '@/components/ui/button';
import type { NavigationItem } from '@/types/layout.types';
import { cn } from '@/utils';
import { LegacyMobileBottomNavItem } from './LegacyMobileBottomNavItem';

interface LegacyMobileBottomNavProps {
	show: boolean;
	bottomNav: NavigationItem[];
	currentPageName: string;
	onNavigate: (path: string) => void;
	loginPointerProps?: {
		onPointerDown: (event: PointerEvent) => void;
		onClick: (event: MouseEvent) => void;
	};
	isRegisteredUser: boolean;
}

export function LegacyMobileBottomNav({
	show,
	bottomNav,
	currentPageName,
	onNavigate,
	loginPointerProps,
	isRegisteredUser,
}: LegacyMobileBottomNavProps) {
	if (!show) return null;

	return (
		<nav
			className={cn(
				'fixed inset-x-0 bottom-0 z-[100] flex flex-col items-center gap-2 bg-[#101423]/60 py-3 pb-[calc(1rem+env(safe-area-inset-bottom))] backdrop-blur-md',
				!isRegisteredUser && 'rounded-t-3xl'
			)}
			id="bottom-nav"
		>
			{!isRegisteredUser && (
				<Button
					{...loginPointerProps}
					className="h-11 w-[95%] rounded-full border-b border-[#1E2748] bg-[#2667FF] text-base font-bold text-[#F7F7F8] hover:bg-[#2667FF]/80"
				>
					Login
				</Button>
			)}
			<div className="flex w-full items-center px-2">
				{bottomNav.map((item) => {
					let isActive = currentPageName === item.name;

					if (item.name === 'Events') {
						isActive = ['LobbyDetails', 'EventDetails'].includes(currentPageName) || isActive;
					} else if (item.name === 'Home') {
						isActive = currentPageName === 'Auth' || isActive;
					}

					return (
						<LegacyMobileBottomNavItem
							key={item.name}
							item={item}
							isActive={isActive}
							onNavigate={onNavigate}
						/>
					);
				})}
			</div>
		</nav>
	);
}
